import * as z from 'zod';
import { Bool, defineEnvironment, Host, Port } from './env-builder.js';
export const ENV = defineEnvironment($ => ({
    NODE_ENV: $('NODE_ENV', z.enum(['development', 'production']).default('development')),
    DATABASE: {
        NAME: $('DATABASE_NAME', z.string().default('cypro')),
        HOST: $('DATABASE_HOST', Host('localhost')),
        PORT: $('DATABASE_PORT', Port(5432)),
        USERNAME: $('DATABASE_USERNAME', z.string().default('cypro')),
        PASSWORD: $('DATABASE_PASSWORD', z.string().default('cypro')),
        SECURE: $('DATABASE_SECURE', Bool()),
    },
    AMMS_SYSTEM: $('AMMS_SYSTEM', Bool(false)),
    SMART_COMPOUNDER_ENABLED: $('SMART_COMPOUNDER_ENABLED', Bool(false)),
}));
//# sourceMappingURL=env.js.map